import { BlocksContent } from '@strapi/blocks-react-renderer';

import { AwardType } from '@/types/awards';
import { LinkItem, StrapiImage, StrapiSeo } from '@/types/common';

export interface CaseStudyDto {
	id: number;
	seo?: StrapiSeo;
	tags?: CaseStudyTagDto[];
	websiteUrl?: string;
	cardPreview?: CaseCardPreview[];
	awards?: CaseStudyAwardDto[];
	content?: unknown[];
	previewTitle?: string;
	nextWork?: {
		subtitle?: string;
		pretitle?: string;
		background: StrapiImage;
		title: BlocksContent;
		cta: LinkItem;
		maxWidthTitle?: 'width550' | 'width600' | 'width650' | 'width700' | 'width750' | 'width800';
	};
}

export enum CaseStudyTagCategory {
	SERVICE = 'service',
	INDUSTRY = 'industry'
}

export interface CaseStudyTagDto {
	id: number;
	name: string;
	category: CaseStudyTagCategory;
	caseStudies?: CaseStudyDto[];
}

export interface CaseCardPreview {
	id: number;
	title?: BlocksContent;
	subtitle?: string;
	url?: string;
	image?: StrapiImage;
	videoUrl?: string;
	thumbnailUrl?: string;
}

export interface CaseStudyAwardDto {
	id: number;
	type: AwardType;
	year: string;
	detailedDate?: string;
	shortName: string;
	fullName?: string;
	externalLink?: string;
}
